<div class="page-not-found-container">
  <div class="content">
    <h1 class="title">Page not found</h1>
    <div class="code">404</div>
    <a [routerLink]="['/company']" class="navigation-link"
      >Back to home page<i class="icon-double-chevron-right"></i></a
    >
  </div>
</div>
